import { render } from "./menu-topbar.vue?vue&type=template&id=3d6dad2a"
import script from "./menu-topbar.vue?vue&type=script&lang=js"
export * from "./menu-topbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__